import React from "react";
import { BaseLayout } from "@components/components";
import { claimantSidebarData } from "@config/debtor";
import { useTranslation } from "react-i18next";

export const ClaimantBase = () => {
    const { t } = useTranslation();
    return <BaseLayout data={claimantSidebarData(t)} />;
};
